import React, { useState } from 'react';
import { isLegacyHost, productionUrlForCurrentPage, PRODUCTION_HOST } from '../../utils/domains';
import './LegacyDomainBanner.css';

const DISMISS_KEY = 'legacy-domain-banner-dismissed';

/**
 * Shown only on the domain being retired, on every route including the login screen: someone
 * arriving on an old bookmark should learn the new address before they sign in, not after.
 *
 * Dismissal is per browser SESSION, not permanent. This is a deadline rather than a preference, so
 * closing it on Tuesday should not hide it again on Thursday. The link carries the current path
 * across, and the auth cookie lives on the API host rather than this one, so following it does not
 * cost the user their session.
 *
 * Temporary by design. Delete this file, its CSS and its mount in App.js on 2026-09-22; see
 * utils/domains.js.
 */
const LegacyDomainBanner = () => {
  const [dismissed, setDismissed] = useState(() => {
    try {
      return window.sessionStorage.getItem(DISMISS_KEY) === '1';
    } catch (_) {
      return false;
    }
  });

  if (!isLegacyHost() || dismissed) return null;

  const dismiss = () => {
    setDismissed(true);
    try {
      window.sessionStorage.setItem(DISMISS_KEY, '1');
    } catch (_) {
      /* Blocked storage must not keep the banner from closing. */
    }
  };

  return (
    <div className="legacy-domain-banner" role="status" aria-live="polite">
      <span className="legacy-domain-banner__text">
        This address is being retired. GMS E-OPS has moved to{' '}
        <a className="legacy-domain-banner__link" href={productionUrlForCurrentPage()}>
          {PRODUCTION_HOST}
        </a>
        . Please update your bookmarks.
      </span>
      <button
        type="button"
        className="legacy-domain-banner__close"
        onClick={dismiss}
        aria-label="Dismiss the domain change notice"
      >
        ×
      </button>
    </div>
  );
};

export default LegacyDomainBanner;
